import { normalizeOrganizationTreeResponse } from 'src/stores/organization/normalizeTreeNodes';

import { NotebookTreeNode } from 'src/models/organization';

import { Callback } from 'src/util/query/models/Callback';

export class GetTheOrganizationTreeForTheUserQueryCallBack extends Callback<Array<NotebookTreeNode>> {
	public constructor(
		private readonly setNotebookTree: (notebookTree: Array<NotebookTreeNode>) => void,
		private readonly rootNodeId = 'tree_notebooks'
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: unknown): void => {
		this.setNotebookTree(normalizeOrganizationTreeResponse(successResponse, this.rootNodeId));
	};
}
